// const apiDomain = window.location.port === '4888' ? 'http://app.udn-detention.design-ebg.com' : '';
const apiDomain = window.location.host === 'detentionexhibition.udnfunlife.com' ? '' : 'https://udn-detention.design-edg.com';
// const apiDomain = 'https://detentionexhibition.udnfunlife.com';
// http://app.udn-detention.design-ebg.com/

export default {
    getMagazines: `${apiDomain}/api/magazines`,
};
